import simpleSlideshowPrep from "site/simpleSlideshowPrep"
import Swiper, { Lazy, Navigation, Keyboard, EffectFade} from 'imports/swiper'
import audioPlayer from "site/audioPlayer"
function SimpleSlideshow(sel) {
    this.slideshow_sel = sel;
    this.self = this
    this.slider = null
    this.totalSlides = 0
    this.currentSlide = 0
    this.videoPrefix = ''
    this.linkoutSelector = null
}
SimpleSlideshow.prototype.init = function() {
    Swiper.use([Lazy, Navigation, Keyboard]);

    const t = this
    if (t.slideshow_sel==='#slides-top') {
        t.videoPrefix = 'top-video-'
        t.linkoutSelector = $('#slides-top-linkout')
    } else {
        t.videoPrefix = 'btm-video-'
        t.linkoutSelector = $('#slides-bottom-linkout')
    }

    t.totalSlides = $(t.slideshow_sel + " .swiper-wrapper .swiper-slide-primary").length
    let defaultObj = {
        init:false,
        speed: 500,
        grabCursor: true,
        centeredSlides: false,
        loop: false,
        preventClicks: false,
        preventClicksPropagation: false,
        noSwiping:false,

        // Lazy plugin
        preloadImages: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 10,
        },


        // Keyboard plugin
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },

        // Navigation plugin
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },


        //final responsive settings
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {}
    }
    defaultObj.breakpoints[window.mobileBreakpoint] = { //window width is >= 640px
        slidesPerView: 2,
        slidesPerGroup: 2
    }

    t.slider = new Swiper(t.slideshow_sel, defaultObj )
    t.slider.on('afterInit', function () {
        setTimeout(function() {
            $('.btn').css('opacity',1)
        },500)
        if (t.slideshow_sel==='#slides-top') {
            $(".tap-zone.tl").on('click', function (e) {
                e.preventDefault()
                t.slider.slidePrev()
                //if ($('body').hasClass('browser-safari')) {
                    t.safariClick(true)
                //}
            })
            $(".tap-zone.tr").on('click', function (e) {
                e.preventDefault()
                t.slider.slideNext()
                //if ($('body').hasClass('browser-safari')) {
                    t.safariClick(true)
                //}
            })
        } else {
            $(".tap-zone.bl").on('click', function (e) {
                e.preventDefault()
                t.slider.slidePrev()
                //if ($('body').hasClass('browser-safari')) {
                    t.safariClick(true)
                //}

            })
            $(".tap-zone.br").on('click', function (e) {
                e.preventDefault()
                t.slider.slideNext()
                //if ($('body').hasClass('browser-safari')) {
                    t.safariClick(true)
                //}
            })
        }

        $(t.slideshow_sel + "-dots .dot").on('click', function (e) {
            let realIndex = parseFloat($(this).attr('num'))-1
            t.slider.slideTo(realIndex)
            t.safariClick(true)
            //t.setIndicators(t, e.realIndex)
        })

        t.setNextPageAndReader(t, 0)

    }.bind(t))

    t.slider.on('slideChangeTransitionStart', function (e) {
        let previousIndex = e.previousIndex + 1
        let activeIndex = e.activeIndex + 1

        t.currentSlide = activeIndex

        let oldVideo = document.getElementById(t.videoPrefix + previousIndex)
        let newVideo = document.getElementById(t.videoPrefix + activeIndex)
        //console.log('slideChangeTransitionStart', oldVideo, newVideo)
        if (oldVideo) {
            try {
                oldVideo.pause()
                audioPlayer.resumeOnVideoPlay()
            } catch (e) {}
        }
        if (newVideo) {
            try {
                if (!$('body').hasClass('browser-safari')) {
                    //newVideo.currentTime = 0
                }
            } catch (e) {}
        }
    }.bind(t))

    t.slider.on('slideChangeTransitionEnd', function (e) {
        //let previousIndex = e.previousIndex + 1
        let activeIndex = e.activeIndex + 1

        let newVideo = document.getElementById(t.videoPrefix + activeIndex)

        if (newVideo) {
            try {
                if ($('body').hasClass('device-notmobile')) {
                    //t.vidPlayComplex(newVideo)
                    t.safariClick(false)
                }
            } catch (e) {}
        }

        t.setIndicators(t, e.realIndex)
        audioPlayer.close()

        let href = $(t.slideshow_sel + " .swiper-slide-active").attr('data-href')
        if (href && href !== '') {
            $('a',t.linkoutSelector).attr('href', href)
            t.linkoutSelector.addClass('show')
        } else {
            t.linkoutSelector.removeClass('show')
        }

        t.setNextPageAndReader(t, e.realIndex)

    }.bind(t))

    t.slider.init()

}
SimpleSlideshow.prototype.setNextPageAndReader = function(t, realIndex) {
    realIndex = realIndex + 1 //because slide classes start on 1 not 0
    let bg1 = $('.swiper-slide-' + (realIndex + 2)).attr('data-main-image')
    let bg2 = $('.swiper-slide-' + (realIndex + 3)).attr('data-main-image')
    //next page bs
    let thtml = ``
    if (bg1) {
        thtml = `<img src="${bg1}"/>`
    }
    if (bg2) {
        thtml += `<img src="${bg2}"/>`
    }
    if (bg1) {
        $('.next-page').show()
        $('#next-page-images').html(thtml)
    } else {
        $('.next-page').hide()
        $('#next-page-images').html('');
    }
    
    //reader
    let sw = $(window).width()
    let mobileSize = 650
    if (sw < mobileSize) {
        realIndex++ //stupid page 3 thing
    }

    let content1 = $('#popup .page-' + realIndex).html()
    let content2 = ''
    //console.log('realIndex', realIndex, sw)
    if (sw >= mobileSize) {
        realIndex++
        content2 = $('#popup .page-' + realIndex).html()
    }
    //console.log('content1+2', content1, content2, realIndex)
    if (content1 || content2 ) {
        $('.reader').removeClass('hide')
    } else {
        $('.reader').addClass('hide')
    }

}
SimpleSlideshow.prototype.setIndicators = function(t, realIndex) {
    let index = realIndex + 1
    $(t.slideshow_sel + "-dots .dot").removeClass('active')
    for (let i=1;i<=t.totalSlides;i++) {
        if (i<=index) {
            $(t.slideshow_sel + "-dots .dot-"+i).addClass('active')
        }
    }

    if (t.slideshow_sel==='#slides-top') {
        simpleSlideshowPrep.topIndex = index
    } else {
        simpleSlideshowPrep.bottomIndex = index
    }
}

SimpleSlideshow.prototype.vidPlayComplex = function(vid, resetCurrentTime=false) {
    //safari made me do this
    if (resetCurrentTime) {
        vid.currentTime = 0
    }
    vid.muted=false
    setTimeout(function() {
        let promise = vid.play()
        if (promise !== undefined) {
            promise.then(_ => {
            }).catch(error => {
                vid.pause()
                setTimeout(function() {
                    vid.muted=false
                    let promise2 = vid.play()
                    if (promise2 !== undefined) {
                        promise2.then(_ => {
                        }).catch(error => {
                            vid.muted = true
                            vid.play()
                        })
                    }
                }.bind(vid), 150)
            })
        }
    }.bind(vid), 50)

    audioPlayer.pauseOnVideoPlay()
}

SimpleSlideshow.prototype.safariClick = function(resetCurrentTime=false) {
    //if ($('body').hasClass('browser-safari')) {
        let t = this.self

        setTimeout(function () {
            t.playActiveSafariHack(t, resetCurrentTime)
        }.bind(t), 150)
        //t.playActiveSafariHack(t)
    //}
}

SimpleSlideshow.prototype.playActiveSafariHack = function(t, resetCurrentTime=false) {
    let vid = document.getElementById(t.videoPrefix + t.currentSlide)
    if (vid) {
        t.vidPlayComplex(vid)
    }
}

export default SimpleSlideshow
